
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    checkoutStickyText: { type: String, default: "" },
    styles: { type: Object, default: () => {} },
    checkoutButtonText: { type: String, default: "" },
  },

  computed: {
    ...mapState({ topBannerHeight: s => s.app.topBannerHeight }),
    ...mapState("bag", ["selectedShippingRate", "miniCart"]),
    ...mapGetters("bag", [
      "discountValue",
      "isSnoozeMember",
      "isAutoClubMember",
      "isVelocityMember",
    ]),
    shippingCharge() {
      return Number(this.selectedShippingRate?.total_price / 100) || 0;
    },
    displayCheckoutStickyText() {
      if (this.checkoutStickyText.toLowerCase().includes("snooze")) {
        return !this.isSnoozeMember;
      }

      if (this.checkoutStickyText.toLowerCase().includes("velocity")) {
        return !this.isVelocityMember;
      }

      if (this.checkoutStickyText.toLowerCase().includes("auto club")) {
        return !this.isAutoClubMember;
      }

      return false;
    },
  },
};
